import { MesiEnum } from "../enum/mesi-enum";
import { SettoreVO } from "./settoreVO";

export class DatiReportorioManualiVO {
  id: string;
  numero: string;
  data: string;
  anno: string;
  mese: MesiEnum;
  privato: boolean;
  segnatura: string;
  struttureAggiuntive: SettoreVO[];
  strutture: SettoreVO[]; // usate nella form
}
